import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_PROFESSIONSV2_FULFILLED = "FETCH_PROFESSIONSV2_FULFILLED";
export const FETCH_PROFESSIONSV2_REJECTED = "FETCH_PROFESSIONSV2_REJECTED";
export const FETCH_PROFESSIONSV2_PENDING = "FETCH_PROFESSIONSV2_PENDING";
export const RESET_PROFESSIONSV2 = "RESET_PROFESSIONSV2";

export function professionsv2(target) {
  const token = localStorage.getItem("accessToken");

  return (dispatch) => {
    dispatch({
      type: FETCH_PROFESSIONSV2_PENDING, // Pending durumunu dispatch et
    });

    axios({
      method: "get",
      url: `${API_BASE}/api/v3/second-opinion/professions?target=${target}`,
      headers: {
        Authorization: "Bearer " + token,
        "Accept-Language": "tr-tr",
        "Client-Id": localStorage.getItem("One-Id"),
        "One-Id": localStorage.getItem("Client-Id"),
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "69920",
      },
    })
      .then((result) => {
        dispatch({
          type: FETCH_PROFESSIONSV2_FULFILLED, // Başarı durumu
          payload: result.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_PROFESSIONSV2_REJECTED, // Hata durumu
          payload: error,
        });
      });
  };
}

export function resetProfessionsv2() {
  return (dispatch) => {
    dispatch({
      type: RESET_PROFESSIONSV2,
    });
  };
}
